import React, { Component } from 'react';
import './App.css';
import img_state0_elImage from './images/DrinkItem_state0_elImage_650029.jpg';
import Favorite from './Favorite';
import img_state1_elImage from './images/DrinkItem_state0_elImage_650029.jpg';

export default class DrinkItem extends Component {

  // Properties used by this component:
  // drinkName, description, price, image_path, document_key, favoritedocumentid, visualStateIndex

  constructor(props) {
    super(props);
    
    this.state = {
    };
  }
  
  componentWillMount(){
  }
  
  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
    
    
  }

  componentWillReceiveProps(nextProps) {
  }

  // --- Functions for component state index 0 (1 of 2) --- 
  
  onClick_state0_elImage = (ev) => {
    this.setState({visualStateIndexOverride: 1})
  
  }
  
  
  renderState0() {
    const style_state0_elBackground222181 = {
      width: '100%',
      height: '100%',
     };
    const style_state0_elBackground222181_outer = {
      backgroundColor: 'rgba(0, 0, 0, 0.4665)',
     };
    const style_state0_elBackground796657 = {
      width: '100%',
      height: '100%',
     };
    const style_state0_elBackground796657_outer = {
      backgroundColor: '#f6f6f6',
     };
    
    const value_drinkName = this.props.drinkName;
    
    const style_state0_elDrinkName371725 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_text = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      return 'Document_key: '+input;
    }
    
    const value_text = transformPropValue_text(this.props.document_key);
    
    const style_state0_elText174248 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    const style_state0_elImage = {
      backgroundImage: 'url('+(this.props.image_path || img_state0_elImage)+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const value_drinkDescription = this.props.description;
    
    const style_state0_elDrinkDescription726857 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_drinkPrice = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      // This is an example snippet defined in 'User snippets'.
      input=input+'$'
      
      return input;
    }
    
    let value_drinkPrice = transformPropValue_drinkPrice(this.props.price);
    
    const style_state0_elDrinkPrice512016 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };

    let favoritedocumentid=()=>{
      let favorites=this.props.appActions.getDataSheet('userFavorites');
      let userId=this.props.appActions.dataSlots['ds_SlotFirebaseUserId'];
      let drinkId=this.props.document_key;
      
      for (let i=0;i < favorites.items.length; i++){
      if (drinkId.toString()===favorites.items[i].drinkID && userId.toString()===favorites.items[i].userId){
        console.log("found favorite document id: " + favorites.items[i].document_key);
        return favorites.items[i].document_key;
      }
      }
    }

    let transformStateValue_state0_elFavorite964267 = (input) => {
      // This function modifies the value for property 'componentStateId'.
      // There is a variable named 'input' that provides the property value.
      //
      let favorites=this.props.appActions.getDataSheet('userFavorites');
      let userId=this.props.appActions.dataSlots['ds_SlotFirebaseUserId'];
      let drinkId=input;
      
      for (let i=0;i < favorites.items.length; i++){
      if (drinkId.toString()===favorites.items[i].drinkID && userId.toString()===favorites.items[i].userId){
        console.log("found favorite document id: " + favorites.items[i].document_key);
      favoritedocumentid=favorites.items[i].document_key;
       //this.setState({favoritedocumentid:favorites.items[i].document_key});
        return 1;
      }
      }
      return 0;
      
      //if (this.favoritedocumentid !== '' && this.favoritedocumentid != null){
      //	return 1;
      //}
      
      //let tempFavId=this.favoritedocumentid;
      //if (tempFavId !== '' && tempFavId != null){
      //	return 1;
      //}
      
      //return input;
    
    }
    
    return (
      <div className="DrinkItem">
        <div className="background">
          <div className="containerMinHeight state0_elBackground222181" style={style_state0_elBackground222181_outer}>
            <div style={style_state0_elBackground222181} />
          </div>
          
          <div className="state0_elBackground796657" style={style_state0_elBackground796657_outer}>
            <div className="appBg" style={style_state0_elBackground796657} />
          </div>
        </div>
        
        <div className="layoutFlow">
          <div className="state0_elDrinkName371725">
            <div className="headlineFont" style={style_state0_elDrinkName371725}>
              <div>{value_drinkName !== undefined ? value_drinkName : (<span className="propValueMissing">{this.props.locStrings.drinkitem_text_371725}</span>)}</div>
            </div>
          </div>
          
          <div className="state0_elText174248">
            <div className="baseFont" style={style_state0_elText174248}>
              <div>{value_text !== undefined ? value_text : (<span className="propValueMissing">{this.props.locStrings.drinkitem_text_174248}</span>)}</div>
            </div>
          </div>
          
          <div className="state0_elImage">
            <div style={style_state0_elImage} onClick={this.onClick_state0_elImage}  />
          </div>
          
          <div className="state0_elDrinkDescription726857">
            <div className="baseFont" style={style_state0_elDrinkDescription726857}>
              <div>{value_drinkDescription !== undefined ? value_drinkDescription : (<span className="propValueMissing">{this.props.locStrings.drinkitem_drinknamecopy_726857}</span>)}</div>
            </div>
          </div>
          
          <div className="state0_elDrinkPrice512016">
            <div className="headlineFont" style={style_state0_elDrinkPrice512016}>
              <div>{value_drinkPrice !== undefined ? value_drinkPrice : (<span className="propValueMissing">{this.props.locStrings.drinkitem_drinkdescriptioncopy_512016}</span>)}</div>
            </div>
          </div>
          
          <div className="state0_elSpacer38161">
            <div />
          </div>
        </div>
        
        <div className="foreground">
          <div className="hasNestedComps state0_elFavorite964267">
            <Favorite document_key={this.props.document_key || "DlApgjOrVVYZ4TTaNsJM"} favoritedocumentid={favoritedocumentid() || ""} visualStateIndex={transformStateValue_state0_elFavorite964267(this.props.document_key)} ref={(el)=> this._state0_elFavorite964267 = el} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />
          </div>
        </div>
      </div>
    )
  }
  
  // --- Functions for component state index 1 (2 of 2) --- 
  
  onClick_state1_elImage = (ev) => {
    this.setState({visualStateIndexOverride: 0})
  
  }
  
  
  renderState1() {
    const style_state1_elBackground222181 = {
      width: '100%',
      height: '100%',
     };
    const style_state1_elBackground222181_outer = {
      backgroundColor: 'rgba(0, 0, 0, 0.4665)',
     };
    const style_state1_elBackground796657 = {
      width: '100%',
      height: '100%',
     };
    const style_state1_elBackground796657_outer = {
      backgroundColor: '#f6f6f6',
     };
    
    const value_drinkName = this.props.drinkName;
    
    const style_state1_elDrinkName371725 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_text = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      return 'Document_key: '+input;
    }
    
    const value_text = transformPropValue_text(this.props.document_key);
    
    const style_state1_elText174248 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    
    const value_image = this.props.image_path;
    
    const style_state1_elImage = {
      height: 'auto',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const value_drinkDescription = this.props.description;
    
    const style_state1_elDrinkDescription726857 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_drinkPrice = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      // This is an example snippet defined in 'User snippets'.
      input=input+'$'
      
      return input;
    }
    
    const value_drinkPrice = transformPropValue_drinkPrice(this.props.price);
    
    const style_state1_elDrinkPrice512016 = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };

    const favoritedocumentid='test2';

    let transformStateValue_state1_elFavorite964267 = (input) => {
      // This function modifies the value for property 'componentStateId'.
      // There is a variable named 'input' that provides the property value.
      //
      let favorites=this.props.appActions.getDataSheet('userFavorites');
      let userId=this.props.appActions.dataSlots['ds_SlotFirebaseUserId'];
      let drinkId=input;
      
      for (let i=0;i < favorites.items.length; i++){
      if (drinkId.toString()===favorites.items[i].drinkID && userId.toString()===favorites.items[i].userId){
        console.log("found favorite document id: " + favorites.items[i].document_key);
        favoritedocumentid=favorites.items[i].document_key;
        //(this.setState({favoritedocumentid:favorites.items[i].document_key});
        return 1;
      }
      }
      return 0;
      
      //if (this.favoritedocumentid !== '' && this.favoritedocumentid != null){
      //	return 1;
      //}
      
      //let tempFavId=this.favoritedocumentid;
      //if (tempFavId !== '' && tempFavId != null){
      //	return 1;
      //}
      
      //return input;
    
    }
    
    return (
      <div className="DrinkItem">
        <div className="background">
          <div className="containerMinHeight state1_elBackground222181" style={style_state1_elBackground222181_outer}>
            <div style={style_state1_elBackground222181} />
          </div>
          
          <div className="state1_elBackground796657" style={style_state1_elBackground796657_outer}>
            <div className="appBg" style={style_state1_elBackground796657} />
          </div>
        </div>
        
        <div className="layoutFlow">
          <div className="state1_elDrinkName371725">
            <div className="headlineFont" style={style_state1_elDrinkName371725}>
              <div>{value_drinkName !== undefined ? value_drinkName : (<span className="propValueMissing">{this.props.locStrings.drinkitem_text_371725}</span>)}</div>
            </div>
          </div>
          
          <div className="state1_elText174248">
            <div className="baseFont" style={style_state1_elText174248}>
              <div>{value_text !== undefined ? value_text : (<span className="propValueMissing">{this.props.locStrings.drinkitem_text_174248}</span>)}</div>
            </div>
          </div>
          
          <div className="state1_elImage">
            <img style={style_state1_elImage} src={(value_image || img_state1_elImage)} alt="" onClick={this.onClick_state1_elImage}  />
          </div>
          
          <div className="state1_elDrinkDescription726857">
            <div className="baseFont" style={style_state1_elDrinkDescription726857}>
              <div>{value_drinkDescription !== undefined ? value_drinkDescription : (<span className="propValueMissing">{this.props.locStrings.drinkitem_drinknamecopy_726857}</span>)}</div>
            </div>
          </div>
          
          <div className="state1_elDrinkPrice512016">
            <div className="headlineFont" style={style_state1_elDrinkPrice512016}>
              <div>{value_drinkPrice !== undefined ? value_drinkPrice : (<span className="propValueMissing">{this.props.locStrings.drinkitem_drinkdescriptioncopy_512016}</span>)}</div>
            </div>
          </div>
          
          <div className="state1_elSpacer38161">
            <div />
          </div>
        </div>
        
        <div className="foreground">
          <div className="hasNestedComps state1_elFavorite964267">
            <Favorite document_key={this.props.document_key || "DlApgjOrVVYZ4TTaNsJM"} favoritedocumentid={favoritedocumentid || "ei löydy"} visualStateIndex={transformStateValue_state1_elFavorite964267(this.props.document_key)} ref={(el)=> this._state1_elFavorite964267 = el} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />
          </div>
        </div>
      </div>
    )
  }
  
  
  render() {
    switch (parseInt((this.state && this.state.visualStateIndexOverride !== undefined) ? this.state.visualStateIndexOverride : this.props.visualStateIndex, 10)) {
      default:
      case 0:
        return this.renderState0();
      case 1:
        return this.renderState1();
    }
  }
  
}
